var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isSyncronised(_vm.contact))?_c('v-icon',[_vm._v("\n    sync\n  ")]):_vm._e(),(!_vm.isSyncronised(_vm.contact))?_c('v-icon',[_vm._v("\n    sync_disabled\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }